import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Choice from '@components/choice/Choice'

import useReducer from '@store/useReducer'
import * as AdminStore from '@store/admin/admin'

import { FormikHelpers, useFormik } from 'formik'

interface Values {
  space: string
}

const Map = ({ form, onForm }: AdminPlanFormProps) => {
  const init: Values = React.useMemo(() => ({ space: form.space }), [form.space])

  const plans = useReducer(AdminStore.store, (s) => s.plans)
  const spaces = useReducer(AdminStore.store, (s) => s.spaces)

  const items = React.useMemo(
    () => spaces.filter((p) => !plans.find((pl) => pl.localisationId === p.id)),
    [plans, spaces]
  )

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    onForm(vals).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  const options = React.useMemo(
    () => items.map((s) => ({ label: s.libelle, value: s.id })).sort((a, b) => a.label.localeCompare(b.label)),
    [items]
  )
  const opt = options.find((o) => values.space === o.value)

  return (
    <MainContainer>
      <Choice data={options} onItemSelected={(next) => setFieldValue('space', next.value)} value={opt} inline={false} />
    </MainContainer>
  )
}

export default Map

const MainContainer = styled(View)`
  margin: 0 ${(props) => (props.theme.breakpoint === 'phone' ? 24 : 48)}px;
  margin-top: 25px;
  flex: 1;
`
